import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/attention.svg'


const _hoisted_1 = { class: "snackbar" }
const _hoisted_2 = { class: "snackbar__inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "snackbar__icon" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "icon"
        })
      ], -1)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "snackbar__text" }, " Срок действия сессии истек, пожалуйста, обновите страницу. ", -1)),
      _createElementVNode("div", {
        class: "snackbar__refresh",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args)))
      }, " Обновить ")
    ])
  ]))
}